import React from "react";

export const ReportIconSvg = ({ pathNames, color }) => {
  const strokeColor = pathNames?.includes("/home/report")
    ? "#ffffff"
    : color
    ? color
    : "#667085";

  return (
    <div>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Bar chart with trend line */}
        <path
          d="M3.33333 17.5H16.6667"
          stroke={strokeColor}
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <rect
          x="4.58333"
          y="10"
          width="2.5"
          height="6.25"
          rx="0.5"
          stroke={strokeColor}
          strokeWidth="1.8"
        />
        <rect
          x="8.75"
          y="7.5"
          width="2.5"
          height="8.75"
          rx="0.5"
          stroke={strokeColor}
          strokeWidth="1.8"
        />
        <rect
          x="12.9167"
          y="4.16667"
          width="2.5"
          height="12.0833"
          rx="0.5"
          stroke={strokeColor}
          strokeWidth="1.8"
        />
        <path
          d="M4.58333 7.5L8.75 4.16667L12.0833 5.83333L16.25 2.5"
          stroke={strokeColor}
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
